/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    'Algo ha ido mal. Inténtalo de nuevo en unos minutos.',
  'goal-content.goal-about-content.description-edit-button': 'Editar',
  'goal-content.goal-about-content.description-title': 'Descripción',
  'goal-content.goal-about-content.placeholder-description':
    'Describe brevemente por qué es importante esta meta y cómo se mide el éxito, de modo que puedas proporcionar a los seguidores una perspectiva común.',
  'goal-content.goal-content-about.edit-description-error-title': 'Error al editar la descripción de la meta',
  'goal-content.goal-content-update-date.edited': '(editado)',
  'goal-content.goal-content-update-date.edited-tooltip': 'Fecha de edición: {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(última edición por {name})',
  'goal-content.goal-content-updates.add-update': 'Añadir actualización',
  'goal-content.goal-content-updates.archived': 'Archivado',
  'goal-content.goal-content-updates.at-risk': 'En riesgo',
  'goal-content.goal-content-updates.cancelled': 'Cancelado',
  'goal-content.goal-content-updates.completed': 'Completados 🎉',
  'goal-content.goal-content-updates.date-changed': 'Fecha cambiada',
  'goal-content.goal-content-updates.edit-update': 'Editar',
  "goal-content.goal-content-updates.for-date'": 'para {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Última actualización',
  'goal-content.goal-content-updates.missed-update-message': 'No se ha publicado ninguna actualización',
  'goal-content.goal-content-updates.new-due-date': 'Nueva fecha de vencimiento',
  'goal-content.goal-content-updates.new-state': 'Nuevo estado',
  'goal-content.goal-content-updates.no-updates-description': 'Aún no hay actualizaciones para esta meta.',
  'goal-content.goal-content-updates.off-track': 'No según lo previsto',
  'goal-content.goal-content-updates.old-due-date': 'Antigua fecha de vencimiento',
  'goal-content.goal-content-updates.old-state': 'Antiguo estado',
  'goal-content.goal-content-updates.on-track': 'Según lo previsto',
  'goal-content.goal-content-updates.paused': 'En pausa',
  'goal-content.goal-content-updates.pending': 'Pendiente',
  'goal-content.goal-content-updates.previous-updates-title': 'Actualizaciones anteriores',
  'goal-content.goal-content-updates.share-update': 'Compartir',
  'goal-content.goal-content-updates.status-changed': 'Estado cambiado',
  'goal-content.goal-content-updates.write-update-button': 'Escribir una actualización',
  'goal-content.goal-update-composer.modal-title': 'Publica tu actualización',
  'goal-content.goal-update-composer.post-button-label': 'Publicar actualización',
};
